import { Avatar, IconButton, Popover, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useContext, useState } from "react";
import { font } from "../styles/font";
import { theme } from "../styles/theme";
import { stringAvatar, stringToArray, stringToColor } from "../utility/string";
import { ModuleType } from "../constants";
import { ApplicationContext } from "../context/application_ctx";
import { useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
export const Header = ({
  dashboardQuery,
  activeTab,
  setActiveTab,
  setDockMenu,
  admin,
  dialog,
  setAdminDock,
  adminProfileDetail,
}) => {
  console.log(dashboardQuery, activeTab, admin, "props");
  // context
  const { profileDetails, tableView, header } = useContext(ApplicationContext);

  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleProfile = () => {
    setAnchorEl(false);
    setActiveTab(ModuleType?.userProfile);
    navigate("/user-profile");
  };
  const handleCompanyProfile = () => {
    setAnchorEl(false);
    setActiveTab(ModuleType?.organisationProfile);
    navigate("/company-profile");
  };

  const handleLogout = () => {
    localStorage.clear();
    if (admin) {
      navigate("/admin-signin");
    } else {
      navigate("/signin");
      setActiveTab(0);
    }
  };

  return (
    <>
      <Box
        width="100%"
        zIndex="100"
        position="Sticky"
        top="-11px"
        height="64px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        py={2}
        sx={{ backdropFilter: "blur(5px)" }}
      >
        <Box
          width="100%"
          position="Sticky"
          top="0px"
          // minHeight="64px"
          display="flex"
          alignItems="center"
          sx={{ backdropFilter: "blur(5px)" }}
          gap="16px"
        >
          {/* {dashboardQuery ? (
          <IconButton onClick={() => setHamburger(!hamburger)}>
            {hamburger ? (
              <MenuIcon sx={{ color: theme.col_2, fontSize: "40px" }} />
            ) : (
              <CloseIcon sx={{ color: theme.col_2, fontSize: "40px" }} />
            )}
          </IconButton>
        ) : (
          <></>
        )} */}
          {admin ? (
            <Box
              display={"flex"}
              width="60x"
              justifyContent="center"
              height="34px"
              ml={2}
            >
              <img
                width={"100%"}
                height="100%"
                src={require("../assets/images/logo.png")}
                alt="Mindamigo"
              />
            </Box>
          ) : (
            <></>
          )}
          {dashboardQuery ? (
            <MenuIcon
              onClick={() => (admin ? setAdminDock(true) : setDockMenu(true))}
              sx={{ fontSize: "34px", color: theme.col_2 }}
            />
          ) : (
            <></>
          )}

          <Typography
            fontFamily={font.family.fm_2}
            flex={1}
            fontSize={font.size.fs_2}
            fontWeight="bold"
            color={theme.col_2}
          >
            {admin
              ? " Admin-Dashboard"
              : activeTab === ModuleType?.organisationDashboard
              ? tableView === 2
                ? "Audit"
                : tableView === 3
                ? "Payment Details"
                : tableView === 1
                ? header
                : "Dashboard"
              : activeTab === ModuleType?.onBoarding
              ? "Employees Onboarding"
              : activeTab === ModuleType?.profile
              ? " Profile"
              : activeTab === ModuleType?.licence
              ? "Licence"
              : activeTab === ModuleType?.audit
              ? "Audit"
              : activeTab === ModuleType?.userProfile
              ? "User Profile"
              : activeTab === ModuleType?.organisationProfile
              ? "Organisation Profile"
              : activeTab === ModuleType?.maRepresentative
              ? "MA Representative"
              : "User On-Boarding"}

            {/* {admin ? 'Admin Dashboard' : activeTab === 0 ? 'User On-Boarding' : "User Profile"}
            {admin ? 'Admin Dashboard' : activeTab === 0 ? 'User On-Boarding' : "User Profile"}


            {activeTab === 2 && "Licence"} */}
          </Typography>
          {dialog ? (
            <></>
          ) : (
            <Box
              alignItems="center"
              onClick={handleClick}
              pl={2}
              pr={1.5}
              py={1}
              gap="8px"
              sx={{
                cursor: "pointer",
                "&:hover": { background: theme.col_2_alpha2 },
              }}
              display="flex"
              border={`1px solid ${theme.col_5}`}
              backgroundColor={theme.col_4}
              borderRadius="6px"
            >
              <Typography
                color={theme.col_6}
                fontWeight="bold"
                fontFamily={font.family.fm_2}
                fontSize={font.size.fs_5}
              >
                {admin ? adminProfileDetail?.name : profileDetails?.companyName}
              </Typography>

              <Box
                display="flex"
                alignItems="center"
                width="30px"
                height="30px"
                borderRadius="50px"
                flexDirection="column"
                justifyContent="center"
                backgroundColor={stringToColor(
                  admin
                    ? adminProfileDetail?.name?.split(" ")[0] ?? "green"
                    : profileDetails?.companyName?.split(" ")[0] ?? "green"
                )}
              >
                <Typography
                  fontFamily={font.family.fm_2}
                  fontSize={font.size.fs_3}
                  fontWeight="bold"
                  color={theme.col_4}
                  textTransform="capitalize"
                >
                  {stringToArray(
                    admin
                      ? adminProfileDetail?.name?.split(" ")[0] ?? ""
                      : profileDetails?.companyName?.split(" ")[0] ?? ""
                  )}
                </Typography>
              </Box>
            </Box>
          )}
          <Popover
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            // PaperProps={{component:{borderRadius:'12px'}}}
            sx={{
              ".MuiPopover-paper": {
                borderRadius: "15px",
                border: `2px solid ${theme.bgBorder}`,
                boxShadow: "none",
              },
            }}
          >
            <Box
              width={"300px"}
              display="flex"
              alignItems="center"
              flexDirection="column"
              backgroundColor={theme.col_4}
              minHeight="160px"
              maxHeight="fit-content"
            >
              <Box
                display="flex"
                alignItems="center"
                border={"1px solid rgb(229, 234, 242)"}
                width={"100%"}
                minWidth="227px"
                height="100px"
                borderRadius="8px"
                //   backgroundColor={theme.col_2}
                flexDirection="row"
                gap="13px"
                paddingLeft="20px"
              >
                <Avatar
                  {...stringAvatar(
                    admin
                      ? adminProfileDetail?.name?.split(" ")[0]
                      : profileDetails?.companyName?.split(" ")[0]
                  )}
                />

                <Box
                  display="flex"
                  alignItems="flex-start"
                  //   backgroundColor={theme.col_4}
                  flexDirection="column"
                  flex="1"
                >
                  <Typography
                    fontFamily={font.family.fm_2}
                    fontSize={font.size.fs_4}
                    color={theme.col_6}
                    fontWeight="bold"
                    textTransform="capitalize"
                  >
                    {admin
                      ? adminProfileDetail?.name
                      : profileDetails?.companyName}
                  </Typography>
                  <Typography
                    fontFamily={font.family.fm_2}
                    fontSize={font.size.fs_4}
                    color={theme.col_8}
                    fontWeight="bold"
                    // textTransform="capitalize"
                  >
                    {admin ? adminProfileDetail?.email : <></>}
                  </Typography>
                </Box>
              </Box>
              <Box
                display="flex"
                width="97%"
                flex="1"
                justifyContent="center"
                alignItems="center"
                gap="6px"
                flexDirection="column"
                py={1}
                // border="2px solid blue"
              >
                {!admin && (
                  <>
                    <IconButton
                      sx={{
                        borderRadius: "40px",
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-start",
                        paddingLeft: "20px",
                      }}
                      onClick={handleProfile}
                    >
                      <Typography
                        fontFamily={font.family.fm_2}
                        fontSize={font.size.fs_4}
                        color={theme.col_6}
                        fontWeight="bold"
                      >
                        User Profile
                      </Typography>
                    </IconButton>
                    <IconButton
                      sx={{
                        borderRadius: "40px",
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-start",
                        paddingLeft: "20px",
                      }}
                      onClick={handleCompanyProfile}
                    >
                      <Typography
                        fontFamily={font.family.fm_2}
                        fontSize={font.size.fs_4}
                        color={theme.col_6}
                        fontWeight="bold"
                      >
                        Company Profile
                      </Typography>
                    </IconButton>
                  </>
                )}
                <IconButton
                  sx={{
                    borderRadius: "40px",
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-start",
                    paddingLeft: "20px",
                  }}
                  onClick={() => handleLogout()}
                >
                  <Typography
                    fontFamily={font.family.fm_2}
                    fontSize={font.size.fs_4}
                    color={theme.col_6}
                    fontWeight="bold"
                  >
                    Sign out
                  </Typography>
                </IconButton>
              </Box>
            </Box>
          </Popover>
        </Box>
        {/* {!hamburger ? (
        <Box
          width="100%"
          backgroundColor={theme.col_4}
        //   position="absolute"
        //   zIndex={100}
          //   top="0px"
          height="240px"
          display="flex"
          flexDirection={"column"}
          alignItems="center"
          sx={{ backdropFilter: "blur(15px)" }}
          paddingTop="12px"
          gap="8px"
        >
          {navItems.map((items, i) => {
            return (
              <ButtonCustom
                borderRadius={"20px 20px 20px 20px"}
                width={"96%"}
                typography={
                  <Typography
                    fontFamily={font.family.fm_2}
                    textTransform={"capitalize"}
                    fontSize={font.size.fs_3}
                    fontWeight="bold"
                    color={activeTab === i ? theme.col_1 : theme.col_6}
                  >
                    {items.label}
                  </Typography>
                }
                onClick={() => setActiveTab(i)}
                background={activeTab === i ? theme.col_2 : "white"}
                backgroundRipple={theme.col_2}
              />
            );
          })}
        </Box>
      ) : (
        <></>
      )} */}
      </Box>
    </>
  );
};
